import { Client } from '@/common/services/Client';

interface AssignRenewalRequest {
  renewalUuids: string[];
}

export async function assignRenewal(renewalUuid: string): Promise<void> {
  const response = await Client.patch<void, AssignRenewalRequest>({
    body: {
      renewalUuids: [renewalUuid],
    },
    endpoint: `/renewals/assign`,
  });
  return response.data;
}
